var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.75C8.75 12.1977 8.30228 11.75 7.75 11.75C7.19772 11.75 6.75 12.1977 6.75 12.75C6.75 13.3023 7.19772 13.75 7.75 13.75C8.30228 13.75 8.75 13.3023 8.75 12.75Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 15.75C8.30228 15.75 8.75 16.1977 8.75 16.75C8.75 17.3023 8.30228 17.75 7.75 17.75C7.19772 17.75 6.75 17.3023 6.75 16.75C6.75 16.1977 7.19772 15.75 7.75 15.75Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.75C12.3023 15.75 12.75 16.1977 12.75 16.75C12.75 17.3023 12.3023 17.75 11.75 17.75C11.1977 17.75 10.75 17.3023 10.75 16.75C10.75 16.1977 11.1977 15.75 11.75 15.75Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 11.75C12.3023 11.75 12.75 12.1977 12.75 12.75C12.75 13.3023 12.3023 13.75 11.75 13.75C11.1977 13.75 10.75 13.3023 10.75 12.75C10.75 12.1977 11.1977 11.75 11.75 11.75Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.75C16.75 12.1977 16.3023 11.75 15.75 11.75C15.1977 11.75 14.75 12.1977 14.75 12.75C14.75 13.3023 15.1977 13.75 15.75 13.75C16.3023 13.75 16.75 13.3023 16.75 12.75Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3.75C8.5 3.33579 8.16421 3 7.75 3C7.33579 3 7 3.33579 7 3.75V4H5.75C4.23122 4 3 5.23122 3 6.75V18.75C3 20.2688 4.23122 21.5 5.75 21.5H17.75C19.2688 21.5 20.5 20.2688 20.5 18.75V6.75C20.5 5.23122 19.2688 4 17.75 4H16.5V3.75C16.5 3.33579 16.1642 3 15.75 3C15.3358 3 15 3.33579 15 3.75V4H8.5V3.75ZM15 5.5H8.5V5.75C8.5 6.16421 8.16421 6.5 7.75 6.5C7.33579 6.5 7 6.16421 7 5.75V5.5H5.75C5.05964 5.5 4.5 6.05964 4.5 6.75V8H19V6.75C19 6.05964 18.4404 5.5 17.75 5.5H16.5V5.75C16.5 6.16421 16.1642 6.5 15.75 6.5C15.3358 6.5 15 6.16421 15 5.75V5.5ZM4.5 18.75V9.5H19V18.75C19 19.4404 18.4404 20 17.75 20H5.75C5.05964 20 4.5 19.4404 4.5 18.75Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCalendar);
export default __webpack_public_path__ + "static/media/icn-calendar.a543e82098cfed9fa3ecf4b2b9b7de2f.svg";
export { ForwardRef as ReactComponent };